import React from 'react';
import RenderDetail from './RenderDetail';

const ReturnDetail = ({ match }) => {
  return <RenderDetail match={match} />;
};

export default ReturnDetail;
